const AboutUsScreen = () => {
    return(
        <p>About Us Page</p>
    )
}

export default AboutUsScreen